import { render, staticRenderFns } from "./religiousBackground.vue?vue&type=template&id=7a118fde"
import script from "./religiousBackground.vue?vue&type=script&lang=js"
export * from "./religiousBackground.vue?vue&type=script&lang=js"
import style0 from "./religiousBackground.vue?vue&type=style&index=0&id=7a118fde&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports